<template>
  <div class="wrapper">
    <spinner />
  </div>
</template>

<script>
  import spinner from '@/components/widgets/Spinner';

  export default {
    name: 'VerifyEmail',
    components: {
      spinner,
    },
    async mounted() {
      const { email, code } = this;
      let success = true;
      try {
        if (email && code) {
          const res = await this.$cognitoAuth.verifyEmail(email, code);
          if (res.name === 'ExpiredCodeException') {
            success = false;
          }
        }
      } catch (e) {
        success = false;
      } finally {
        this.$router.push({ name: 'Login', query: { email, success } });
      }
    },
    data() {
      return {
        password: '',
        passwordConfirmation: '',
      };
    },
    computed: {
      code() {
        return this.$route.query.code;
      },
      email() {
        return this.$route.query.email;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// VerifyEmail.vue?1a6edfe2